import React, { useCallback } from "react";
import { Grid, Typography, Button } from "@material-ui/core";
import SuccessIcon from "./icons/SuccessIcon";
import AddHouseholdIcon from "./icons/addHouseholdIcon";
import { useStyles } from "./styles";
import { useAppContext } from "src/providers/AppProvider";
import { useTranslation } from "react-i18next";
interface Props {
  completeProfile: () => void;
}

const SuccessAddressCreate: React.FC<Props> = ({ completeProfile }) => {
  const classes = useStyles();
  const {
    callAppAPI: { toggleModal },
  } = useAppContext();
  const { t } = useTranslation("customers");

  const handleModalClose = useCallback(() => {
    toggleModal({ id: "createCustomerModal", status: false });
  }, []);
  return (
    <Grid container justify="center">
      <Grid item>
        <div className={classes.titleWrapper}>
          <SuccessIcon className={classes.successIcon} />
          <Typography variant="h4">
            {t("labels.create_customer.addresses_form_success.title")}
          </Typography>
        </div>

        <div>
          <Typography variant="body1" className={classes.subtitle}>
            {t("labels.create_customer.addresses_form_success.tips")}
          </Typography>
          <span className={classes.itemWrapper}>
            <AddHouseholdIcon />
            <Typography variant="subtitle2" className={classes.primaryText}>
              {t("labels.create_customer.addresses_form_success.tip1")}
            </Typography>
          </span>
          <Typography variant="body1" className={classes.secondaryText}>
            {t("labels.create_customer.addresses_form_success.optional")}
          </Typography>
        </div>
        <div className={classes.btnGroup}>
          <Button onClick={completeProfile} className={classes.submitBtn} type="submit">
            {t("labels.create_customer.addresses_form_success.complete")}
          </Button>
          <Button onClick={handleModalClose} className={classes.cancelBtn}>
            {t("labels.create_customer.addresses_form_success.cancel")}
          </Button>
        </div>
      </Grid>
    </Grid>
  );
};

export default SuccessAddressCreate;
